import { getEnvironmentVariable } from "../../global/environmentVariables";
import MainHeaderBCP from "./MainHeaders/MainHeaderBCP";
import MainHeaderLegacy from "./MainHeaders/MainHeaderLegacy";

const IS_CATAN = getEnvironmentVariable("COMPANY_FLAG") === "catan";

export default function MainHeader(props) {
  if (IS_CATAN) {
    return <MainHeaderLegacy {...props} />;
  } else {
    return <MainHeaderBCP {...props} />;
  }
}
